export default "__VITE_ASSET__D_x7gCuS__"